import { useLayoutEffect, useRef, useState } from 'react'

/** Keep the last answer reachable when attachments or upload errors grow the dock. */
export function useComposerSpace() {
  const dock = useRef<HTMLDivElement>(null)
  const [height, setHeight] = useState(210)
  useLayoutEffect(() => {
    const element = dock.current
    if (!element) return
    const measure = () => setHeight(Math.ceil(element.getBoundingClientRect().height) + 24)
    const observer = new ResizeObserver(measure)
    observer.observe(element)
    measure()
    return () => observer.disconnect()
  }, [])
  return { dock, height }
}
